"use strict";

var _interopRequireWildcard = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _date = require("@/utils/date");
var _validate = require("@/utils/validate");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var agency = _interopRequireWildcard(require("@/api/agency"));
var user = _interopRequireWildcard(require("@/api/user"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    var validateEmail = function validateEmail(rule, value, callback) {
      if (!value) {
        callback(new Error("Email is required"));
      } else if (!(0, _validate.validEmail)(value)) {
        callback(new Error("Email is invalid"));
      } else {
        callback();
      }
    };
    return {
      dialogLoading: false,
      objLevelName: {
        lv1: "Master Agent",
        lv2: "Distributor",
        lv3: "Retailer",
        lv4: "Employee"
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      listLoading: false,
      total: 0,
      loadingButton: false,
      listQuery: {
        page: 1,
        limit: 10,
        search: ""
      },
      arrData: [],
      dialogVisible: false,
      tempData: {
        name: "",
        email: "",
        username: "",
        password: "",
        agencyLevelId: null,
        parentId: null
      },
      agencyLevel: [],
      arrUser: [],
      dialogStatus: "",
      rootTree: [],
      rules: {
        name: {
          required: true,
          message: "Name is required",
          trigger: "submit"
        },
        username: {
          required: true,
          message: "Username is required",
          trigger: "submit"
        },
        password: {
          required: true,
          message: "Password is required",
          trigger: "submit"
        },
        email: {
          required: true,
          trigger: "submit",
          validator: validateEmail
        }
      }
    };
  },
  computed: {
    arrDataTemp: function arrDataTemp() {
      var _this = this;
      this.listLoading = true;
      var arr = [];
      if (this.listQuery.sort === "" || this.listQuery.sort === "all") {
        arr = this.arrData.filter(function (e) {
          return (e.firstname + " " + e.lastname).toLowerCase().includes(_this.listQuery.fullname.toLowerCase());
        });
      } else {
        arr = this.arrData.filter(function (e) {
          return (e.firstname + " " + e.lastname).toLowerCase().includes(_this.listQuery.fullname.toLowerCase()) && e.isBlock == _this.listQuery.sort;
        });
      }
      this.total = arr.length;
      var indexStart = this.listQuery.page * this.listQuery.limit - this.listQuery.limit;
      var indexEnd = indexStart + this.listQuery.limit;
      indexEnd = indexEnd > arr.length ? arr.length : indexEnd;
      var res = [];
      if (arr.length) {
        for (var i = indexStart; i < indexEnd; i++) {
          var element = arr[i];
          res.push(element);
        }
      }
      setTimeout(function () {
        _this.listLoading = false;
      }, 300);
      return res;
    },
    arrUserTemp: function arrUserTemp() {
      return this.agencyLevel[this.tempData.agencyLevelId - 2].agencys;
    }
  },
  created: function created() {
    this.getAgencyLevel();
    this.getList();
  },
  methods: {
    getTreeRoot: function getTreeRoot(userId) {
      var _this2 = this;
      var tmp = {};
      user.getRootTree(userId).then(function (res) {
        res.data.forEach(function (element) {
          if (!tmp["lv".concat(element.agencyLevelId)]) {
            tmp["lv".concat(element.agencyLevelId)] = [];
          }
          tmp["lv".concat(element.agencyLevelId)].push(element);
        });
        _this2.rootTree = [];
        Object.keys(tmp).forEach(function (key) {
          var obj = {
            label: _this2.objLevelName[key],
            children: tmp[key].map(function (item) {
              return {
                id: item.id,
                label: item.name
              };
            })
          };
          _this2.rootTree.push(obj);
        });
      });
    },
    handleUnBlock: function handleUnBlock(userId) {
      var _this3 = this;
      this.$confirm("This technician will be unblock. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(function () {
        user.unBlockUser(userId).then(function () {
          _this3.arrData.forEach(function (element) {
            if (element.id == userId) {
              element.isActive = 1;
            }
          });
          _this3.$message({
            type: "success",
            message: "Unblock technician successfully"
          });
        });
      });
    },
    handleBlock: function handleBlock(userId) {
      var _this4 = this;
      this.$confirm("This user will be blocked. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(function () {
        user.blockUser(userId).then(function () {
          _this4.arrData.forEach(function (element) {
            if (element.id == userId) {
              element.isActive = 0;
            }
          });
          _this4.$message({
            type: "success",
            message: "Block user successfully"
          });
        });
      });
    },
    getAgencyLevel: function getAgencyLevel() {
      var _this5 = this;
      agency.getAllLevel().then(function (res) {
        _this5.agencyLevel = res.data;
      });
    },
    handleImgError: function handleImgError(event) {
      event.currentTarget.src = require("@/assets/images/avatar_default.svg");
    },
    resetPassword: function resetPassword(userId) {
      var _this6 = this;
      this.$prompt("Enter new password", "Reset password", {
        confirmButtonText: "Reset password",
        cancelButtonText: "Close"
        // @ts-ignore
      }).then( /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
          var value;
          return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                value = _ref.value;
                _this6.listLoading = true;
                _context.prev = 2;
                _context.next = 5;
                return user.resetPasswordDry({
                  password: value,
                  id: userId
                });
              case 5:
                _this6.$message.success("Reset password successfully!");
              case 6:
                _context.prev = 6;
                _this6.listLoading = false;
                return _context.finish(6);
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[2,, 6, 9]]);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    resetTempData: function resetTempData() {
      this.tempData = {
        firstname: "",
        phone: "",
        address: "",
        email: ""
      };
    },
    getData: function getData(row) {
      var _this7 = this;
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this7.$refs["dataForm"].clearValidate();
      });
      this.dialogLoading = true;
      user.getInfoById(row.id).then(function (res) {
        _this7.tempData = res.data;
      }).finally(function () {
        _this7.dialogLoading = false;
      });
    },
    editData: function editData() {
      var _this8 = this;
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this8.loadingButton = true;
          var data = {
            username: _this8.tempData.username,
            name: _this8.tempData.name,
            email: _this8.tempData.email
          };
          var userId = _this8.tempData.id;
          user.update(userId, data).then(function (res) {
            _this8.$message({
              message: "Edit successfully!",
              type: "success"
            });
            var index;
            _this8.arrData.forEach(function (element, i) {
              if (element.id == userId) {
                element = _this8.tempData;
              }
            });
            _this8.getList();
            _this8.dialogVisible = false;
          }).finally(function () {
            _this8.loadingButton = false;
          });
        }
      });
    },
    createData: function createData() {
      var _this9 = this;
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          if (!_this9.tempData.agencyLevelId) {
            return _this9.$message({
              message: "Agency level is required",
              type: "error"
            });
          }
          if (_this9.tempData.agencyLevelId != 1 && !_this9.tempData.parentId) {
            return _this9.$message({
              message: "Parent is required",
              type: "error"
            });
          }
          _this9.loadingButton = true;
          user.register(_this9.tempData).then(function (res) {
            _this9.$message({
              message: "Create successfully!",
              type: "success"
            });
            _this9.getList();
            _this9.dialogVisible = false;
          }).finally(function () {
            _this9.loadingButton = false;
          });
        }
      });
    },
    handleAdd: function handleAdd() {
      var _this10 = this;
      this.dialogStatus = "add";
      this.dialogVisible = true;
      this.avatar = "";
      this.workdate = [];
      this.resetTempData();
      // this.tempData.password = randomString(6);
      this.$nextTick(function () {
        _this10.$refs["dataForm"].clearValidate();
      });
      this.getAgencyLevel();
    },
    handleTitleDialog: function handleTitleDialog() {
      if (this.dialogStatus == "edit") {
        return "Info Agency";
      }
      return "Add agency";
    },
    getList: function getList() {
      var _this11 = this;
      this.listLoading = true;
      user.getAllUser(this.listQuery).then(function (res) {
        _this11.arrData = res.data.data;
        _this11.total = res.data.total;
      }).finally(function () {
        _this11.listLoading = false;
      });
    },
    formatDate: function formatDate(timestamp) {
      return (0, _date.formatDate)(timestamp);
    }
  }
};